import { render, staticRenderFns } from "./Pic.vue?vue&type=template&id=2e0162f6&functional=true&"
import script from "./Pic.vue?vue&type=script&lang=js&"
export * from "./Pic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports